export const config = {
    strapiUrl: process.env.REACT_APP_STRAPI_URL!,
    strapiPrefix: process.env.REACT_APP_STRAPI_PREFIX!,
    env: process.env.REACT_APP_ENV!,
    strapi_token: process.env.REACT_APP_STRAPI_TOKEN!,
};
